export default __webpack_public_path__ + "static/media/993.d81cab18.png";